import { useSkinMatchIngredients } from "../../../../hooks/useSkinMatch/useSkinMatch";
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";
import LoadingSpinner from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import { IngredientDetail } from "../IngredientDetail/IngredientDetail";

type Props = {
  ean: string;
  skinMatchIngredientBaseUrl: string;
  pimProductId: string;
  variantId: string;
};
export function IngredientList({
  ean,
  skinMatchIngredientBaseUrl,
  pimProductId,
  variantId,
}: Props) {
  const skinMatchIngredientsData = useSkinMatchIngredients(
    ean,
    skinMatchIngredientBaseUrl,
    pimProductId,
    variantId,
  );

  switch (skinMatchIngredientsData.status) {
    case "No Action":
    case "Error":
      return (
        <Message
          title="Sorry, there's a problem loading the ingredients. Please check back soon."
          type="error"
        />
      );
    case "Loading":
      return <LoadingSpinner title="Loading..." centered />;
    case "Done": {
      const { data } = skinMatchIngredientsData;
      if (data.length === 0) return null;
      return <IngredientDetail data={data} />;
    }
    default: {
      return null;
    }
  }
}
